import { actions } from "@grandvisionhq/state";
import "../add-to-cart/state/add-to-cart/actions.js";
import "../bundles/state/bundles/actions.js";
import "../configurations/state/configurations/actions.js";
import "../data-layer/state/data-layer/actions.js";
const startPrescriptionGlassesConfiguration = actions.action(
  "products/prescription-glasses/start",
  actions.payload()
);
export {
  startPrescriptionGlassesConfiguration
};
//# sourceMappingURL=actions.js.map
